// Styles
import "./AppSnackbar.sass";

// Mixins
import Colorable from "@mixins/colorable";
import Toggleable from "@mixins/toggleable";
import Delayable from "@mixins/delayable";
import { factory as PositionableFactory } from "@mixins/positionable";

// Helpers
import mixins from "@utils/mixins";

export default mixins(
  Colorable,
  Toggleable,
  Delayable,
  PositionableFactory(["absolute", "top", "bottom", "left", "right"])
).extend({
  name: "AppSnackbar",

  props: {
    multiLine: Boolean,
    vertical: Boolean,
    closeDelay: {
      type: [Number, String],
      default: 6000
    }
  },

  computed: {
    classes() {
      return {
        "app-snack_active": this.isActive,
        "app-snack_absolute": this.absolute,
        "app-snack_bottom": this.bottom || !this.top,
        "app-snack_left": this.left,
        "app-snack_multi-line": this.multiLine && !this.vertical,
        "app-snack_right": this.right,
        "app-snack_top": this.top,
        "app-snack_vertical": this.vertical
      };
    }
  },

  watch: {
    isActive() {
      this.setTimeout();
    }
  },

  mounted() {
    this.setTimeout();
  },

  methods: {
    setTimeout() {
      if (this.isActive && this.closeDelay) {
        this.runDelay("close");
      }
    }
  },

  render(h) {
    return h(
      "transition",
      {
        attrs: { name: "app-snack-transition" }
      },
      [
        this.isActive &&
          h(
            "div",
            {
              staticClass: "app-snack",
              class: this.classes,
              on: this.$listeners
            },
            [
              h(
                "div",
                this.setBackgroundColor(this.color, {
                  staticClass: "app-snack__wrapper"
                }),
                [
                  h(
                    "div",
                    {
                      staticClass: "app-snack__content"
                    },
                    this.$slots.default
                  )
                ]
              )
            ]
          )
      ]
    );
  }
});
